async function addAndyCreditBalanceToProfile(node) {
  if (node && node.nodeType === Node.ELEMENT_NODE && node.classList.contains('frcp-profile')) {
    // Find the container to add the new element
    const container = node.querySelector('.frcp-profile-cards-container');
    if (container) {
    const children = container.children;
      if (children.length > 1) {
        try {
          const balanceStorage = localStorage.getItem('andyCreditsBalance');
          const balance = balanceStorage ? JSON.parse(balanceStorage) : null;
          if (balance && balance !== '') {
            const userBalance = '€' + balance.toFixed(2) || '€0,00'; // Adjust according to the actual response structure

            // Check if the new div already exists
            const existingDiv = container.querySelector('.frcp-profile-card--spent');
            if (existingDiv) {
              // If it exists, just update the balance text
              const contentDiv = existingDiv.querySelector('.frcp-profile-card__content');
              if (contentDiv) {
                contentDiv.textContent = userBalance;
              }
            } else {
              // Create the new div element with the required structure
              const newDiv = document.createElement('div');
              newDiv.className = 'frcp-profile-card frcp-card frcp-profile-card--spent';

              const labelDiv = document.createElement('div');
              labelDiv.className = 'frcp-profile-card__label';
              labelDiv.textContent = 'Andy credits';

              const contentDiv = document.createElement('div');
              contentDiv.className = 'frcp-profile-card__content';
              contentDiv.textContent = userBalance;

              newDiv.appendChild(labelDiv);
              newDiv.appendChild(contentDiv);

              // Insert the new element after the second child
              container.insertBefore(newDiv, children[1]);
            }
          }

        } catch (error) {
        console.error('Error fetching user balance:', error);
        }
      }
    }
  }
}

// Callback for MutationObserver
function mutationCallback(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if a div with the class 'frcp-profile' has been added
      mutation.addedNodes.forEach((node) => {
        addAndyCreditBalanceToProfile(node);
      });
    }
  }
}

// Create a MutationObserver instance
const accountProfileObserver = new MutationObserver(mutationCallback);

// Start observing the document body for childList and subtree mutations
accountProfileObserver.observe(document.body, { childList: true, subtree: true });

function checkForProfileCreditBalance() {
  // Example: Trigger the function separately with a specific node
  const profileNode = document.querySelector('.frcp-profile');
  if (profileNode) {
    addAndyCreditBalanceToProfile(profileNode);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  checkForProfileCreditBalance();
});

window.checkForProfileCreditBalance = checkForProfileCreditBalance;
